/* Spanish DISPLAY names for the foods in data/foods.js.
   The English `name`/`servingType` stay the canonical keys everywhere in logic
   (pairsWellWith / recommendedFor matching, the unit rules in
   convertToUserFriendly). These maps are used only to render Spanish labels.
   Keyed by the exact English string; anything missing falls back to English. */

export const FOOD_NAME_ES = {
  Almonds: 'Almendras',
  Apple: 'Manzana',
  Arugula: 'Arúgula',
  Asparagus: 'Espárragos',
  Avocado: 'Aguacate',
  'Baked Potatoes': 'Papas al horno',
  Banana: 'Plátano',
  Broccoli: 'Brócoli',
  'Brussels Sprouts': 'Coles de Bruselas',
  'Canned Tuna': 'Atún enlatado',
  'Casein Protein': 'Proteína de caseína',
  Cashews: 'Nueces de la India',
  'Chia Seeds': 'Semillas de chía',
  'Chicken Breast': 'Pechuga de pollo',
  'Coconut Oil': 'Aceite de coco',
  'Collard Greens': 'Berzas',
  'Cottage Cheese': 'Queso cottage',
  Couscous: 'Cuscús',
  'Cream of Rice (Dry)': 'Crema de arroz (seca)',
  Cucumber: 'Pepino',
  'Dark Chocolate (85%)': 'Chocolate amargo (85%)',
  'Egg Whites': 'Claras de huevo',
  Eggs: 'Huevos',
  Granola: 'Granola',
  'Grass-Fed Butter': 'Mantequilla de pastoreo',
  'Greek Yogurt': 'Yogur griego',
  'Green Beans': 'Ejotes',
  'Ground Bison': 'Bisonte molido',
  Kale: 'Kale',
  'Lean Ground Beef': 'Carne de res molida magra',
  'Lean Ground Turkey': 'Pavo molido magro',
  'Lean Steak': 'Bistec magro',
  'Macadamia Nuts': 'Nueces de macadamia',
  'Medium Size Wrap/Tortilla': 'Tortilla/wrap mediano',
  'Mixed Berries': 'Frutos rojos mixtos',
  'Nut Butter': 'Mantequilla de frutos secos',
  Oats: 'Avena',
  'Olive Oil': 'Aceite de oliva',
  'Pea Protein': 'Proteína de guisante',
  'Pesto Sauce': 'Salsa pesto',
  Pistachios: 'Pistachos',
  Quinoa: 'Quinoa',
  Rice: 'Arroz',
  'Rice Cakes': 'Tortitas de arroz',
  'Romaine Lettuce': 'Lechuga romana',
  Salmon: 'Salmón',
  Seitan: 'Seitán',
  Shrimp: 'Camarones',
  Spinach: 'Espinaca',
  'Sweet Potato': 'Camote',
  'Swiss Chard': 'Acelga',
  Tempeh: 'Tempeh',
  Tofu: 'Tofu',
  'Turkey Bacon': 'Tocino de pavo',
  'Veggie Burger Patty': 'Hamburguesa vegetariana',
  Walnuts: 'Nueces',
  'Whey Protein Isolate': 'Proteína whey aislada',
  'Whole Wheat Bread': 'Pan integral',
  'Whole Wheat Pasta': 'Pasta integral',
  Zucchini: 'Calabacín',
};

export const SERVING_TYPE_ES = {
  oz: 'oz',
  patty: 'unidad',
  scoop: 'medida',
  'scoop (30g)': 'medida (30g)',
  slice: 'rebanada',
  tbsp: 'cda',
  unit: 'unidad',
};

/* Shopping-list units, keyed by the exact English unit convertToUserFriendly
   (helpers/utils.js) writes, including its plurals. Display only. */
export const SHOPPING_UNIT_ES = {
  'containers (32 oz)': 'envases (32 oz)',
  lbs: 'lb',
  'bunches/bags (8 oz)': 'manojos/bolsas (8 oz)',
  oz: 'oz',
  'small bottle': 'botella pequeña',
  sticks: 'barras',
  tbsp: 'cda',
  unit: 'unidad',
  units: 'unidades',
  slice: 'rebanada',
  slices: 'rebanadas',
  patty: 'unidad',
  pattys: 'unidades',
  scoop: 'medida',
  scoops: 'medidas',
};

const isEs = (lng) => /^es/i.test(String(lng || ''));

export const localizeFoodName = (name, lng) =>
  isEs(lng) ? FOOD_NAME_ES[name] || name : name;

export const localizeServingType = (st, lng) =>
  isEs(lng) ? SERVING_TYPE_ES[st] || st : st;

export const localizeShoppingUnit = (unit, lng) =>
  isEs(lng) ? SHOPPING_UNIT_ES[unit] || localizeServingType(unit, lng) : unit;
